// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"BreadCrumb_breadcrumb__AtLHK"};